import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { memo } from "react"

const AuthorSidebarCard = memo(function AuthorSidebarCard({firstName, lastName}) {

    return (
        <div className="flex-container full-width start-justify center-align">
            <FontAwesomeIcon icon={faUser} className="text-gray"></FontAwesomeIcon>
            <p className="text-black left-margin-5p">{firstName + ' ' + lastName}</p>
        </div>
    )
})

export default AuthorSidebarCard